import { render, staticRenderFns } from "./InfiniteBiScroll.vue?vue&type=template&id=32232ff9&scoped=true"
import script from "./InfiniteBiScroll.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfiniteBiScroll.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InfiniteBiScroll.vue?vue&type=style&index=0&id=32232ff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32232ff9",
  null
  
)

export default component.exports